import Step2 from './step-2-view';

export default Step2;
